import "./index.less";

const MAP = new Map();
const CONTEXT = "@drag/dragcontext";
const ORIGIN_POINT = Object.freeze({ x: 0, y: 0 });

const MATRIX_RE = /^matrix\((\d*(?:\.\d+)?)\s*,\s*\d*(?:\.\d+)?,\s*\d*(?:\.\d+)?\s*,\s*(\d*(?:\.\d+)?)\s*,\s*-?\d*(?:\.\d+)?,\s*-?\d*(?:\.\d+)?\s*\)$/;

const handleDrag = (el, binding, vnode) => {
  let startPoint = null;
  let dropContainerBoundary = null;
  let dragBoundary = null;

  const value = binding.value || ORIGIN_POINT;

  let left = value.x;
  let top = value.y;

  let scale = {
    x: 1,
    y: 1
  };

  let animationFrame = null;

  const animationFrameCb = () => {
    Object.assign(el.style, { transform: `translate(${left}px, ${top}px)` });

    animationFrame = requestAnimationFrame(animationFrameCb);
  };

  const getPosition = (e) => {
    if (dropContainerBoundary && dragBoundary && startPoint) {
      left = Math.floor(
        Math.max(
          Math.min(
            e.clientX - dropContainerBoundary.left - startPoint.distanceX,
            dropContainerBoundary.width - dragBoundary.width
          ),
          0
        ) / scale.x
      );
      top = Math.floor(
        Math.max(
          Math.min(
            e.clientY - dropContainerBoundary.top - startPoint.distanceY,
            dropContainerBoundary.height - dragBoundary.height
          ),
          0
        ) / scale.y
      );
    }
  };

  const mousemove = (e) => {
    getPosition(e);
  };

  const mouseup = (e) => {
    startPoint = dragBoundary = dropContainerBoundary = null;
    cancelAnimationFrame(animationFrame);

    if (vnode.data.on && vnode.data.on["drag-change"]) {
      vnode.data.on["drag-change"](left, top);
    }

    scale = { x: 1, y: 1 };

    document.removeEventListener("mousemove", mousemove);
    document.removeEventListener("mouseup", mouseup);
  };

  const handle = (e) => {
    let dropContainer = MAP.get(binding.arg);
    if (!dropContainer) {
      return;
    }

    const match = window.getComputedStyle(dropContainer).transform.match(MATRIX_RE);
    if (match) {
      scale = {
        x: Number.parseFloat(match[1]),
        y: Number.parseFloat(match[2])
      };
    }

    startPoint = { x: e.clientX, y: e.clientY, distanceX: 0, distanceY: 0 };

    dropContainerBoundary = dropContainer.getBoundingClientRect();
    dragBoundary = el.getBoundingClientRect();

    Object.assign(startPoint, {
      distanceX: startPoint.x - dragBoundary.left,
      distanceY: startPoint.y - dragBoundary.top,
    });

    getPosition(e);

    animationFrame = requestAnimationFrame(animationFrameCb);

    document.addEventListener("mousemove", mousemove);
    document.addEventListener("mouseup", mouseup);
  };

  if (!el[CONTEXT]) {
    el[CONTEXT] = {
      removeHandle: handle,
    };
  } else {
    el[CONTEXT].removeHandle = handle;
  }
  return handle;
};

export const drag = {
  bind(el, binding, vnode) {
    if (!binding.arg) {
      return;
    }
    el.addEventListener("mousedown", handleDrag(el, binding, vnode));

    let boundary = {
      x: -Infinity,
      y: -Infinity,
      width: -Infinity,
      height: -Infinity
    };

    if (MAP.get(binding.arg)) {
      boundary = MAP.get(binding.arg).getBoundingClientRect();
    }

    const value = binding.value || ORIGIN_POINT;
    Object.assign(el.style, {
      left: "0px",
      top: "0px",
      transform: `translate(${value.x}px, ${value.y}px)`,
      position: "absolute",
    });

    el.classList.add("cmn-directive-drag");
  },
  update(el, binding, vnode) {
    if (!binding.arg) {
      return;
    }

    el.removeEventListener("mousedown", el[CONTEXT]?.removeHandle);
    el.addEventListener("mousedown", handleDrag(el, binding, vnode));

    const value = binding.value || ORIGIN_POINT;
    Object.assign(el.style, {
      transform: `translate(${value.x}px, ${value.y}px)`,
    });
  },
  unbind(el, binding) {
    if (!binding.arg) {
      return;
    }
    el.removeEventListener("mousedown", el[CONTEXT]?.removeHandle);
    if (el.classList.contains("cmn-directive-drag")) {
      el.classList.remove("cmn-directive-drag");
    }
  },
};

export const drop = {
  bind(el, binding) {
    if (!binding.arg) {
      return;
    }
    MAP.set(binding.arg, el);
  },
  update(el, binding) {
    if (!binding.arg) {
      return;
    }
    MAP.set(binding.arg, el);
  },
  unbind(el, binding) {
    if (!binding.arg) {
      return;
    }
    MAP.delete(binding.arg);
  },
};
